import React from 'react';
import { Link } from "react-router-dom";

const Button = (props) => {
    const {variant, text, to} = props;
    return (
        <div>
            <Link to={to} className={`${variant}`} href="#" id="button">{text}</Link>
        </div>
    )
}

export default Button;